var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("LayoutBase", [
    _c(
      "form",
      {
        staticClass: "c-event-form form",
        attrs: { novalidate: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.validateBeforeSubmit.apply(null, arguments)
          },
        },
      },
      [
        _c("ValidationAlert", {
          attrs: { "error-list": _vm.errors.collect("server") },
        }),
        _vm._v(" "),
        _c("header", { attrs: { id: "content__header" } }, [
          _c("h1", [
            _vm._v(_vm._s(_vm.event.location) + " Conference Registration"),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form__group" }, [
          _c("legend", { staticClass: "form__label" }, [_vm._v("Attendant")]),
          _vm._v(" "),
          _c("div", { staticClass: "c-event-form__user" }, [
            _c("img", {
              staticClass: "avatar c-event-form__avatar",
              attrs: { src: `/images/avatar/${_vm.user.id}`, alt: "" },
            }),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName)
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form__group" },
          [
            _c("FormControlDatepicker", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: `date_format:yyyy-MM-dd|date_between:${_vm.monthStart},${_vm.monthEnd}|required`,
                  expression:
                    "`date_format:yyyy-MM-dd|date_between:${monthStart},${monthEnd}|required`",
                },
              ],
              attrs: {
                required: "",
                error: _vm.errors.first("arrivalDate"),
                name: "arrivalDate",
                "min-date": _vm.monthStartDate,
                "max-date": _vm.endDate,
                label: "Arrival Date",
              },
              model: {
                value: _vm.arrivalDate,
                callback: function ($$v) {
                  _vm.arrivalDate = $$v
                },
                expression: "arrivalDate",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form__group" },
          [
            _c("FormControlDatepicker", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: `date_format:yyyy-MM-dd|date_between:${_vm.monthStart},${_vm.monthEnd}|required`,
                  expression:
                    "`date_format:yyyy-MM-dd|date_between:${monthStart},${monthEnd}|required`",
                },
              ],
              attrs: {
                required: "",
                error: _vm.errors.first("departureDate"),
                name: "departureDate",
                "min-date": _vm.startDate,
                "max-date": _vm.monthEndDate,
                label: "Departure Date",
              },
              model: {
                value: _vm.departureDate,
                callback: function ($$v) {
                  _vm.departureDate = $$v
                },
                expression: "departureDate",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "form__group" }, [
          _c(
            "label",
            { staticClass: "form__label", attrs: { for: "adults" } },
            [_vm._v("Guests - Adults")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form__increment" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--increment",
                attrs: { disabled: _vm.adultGuests <= 0 },
                on: {
                  click: [
                    function ($event) {
                      $event.preventDefault()
                      if ($event.target !== $event.currentTarget) return null
                    },
                    _vm.decrementAdults,
                  ],
                },
              },
              [_vm._v("\n                    -\n                ")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.adultGuests,
                  expression: "adultGuests",
                },
                { name: "validate", rawName: "v-validate" },
              ],
              staticClass: "form__control form__guests",
              attrs: {
                id: "adults",
                type: "number",
                name: "adults",
                min: "1",
                max: "9",
                placeholder: "Enter company's name here...",
                required: "",
              },
              domProps: { value: _vm.adultGuests },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.adultGuests = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--increment",
                attrs: { disabled: _vm.adultGuests >= 9 },
                on: {
                  click: [
                    function ($event) {
                      $event.preventDefault()
                      if ($event.target !== $event.currentTarget) return null
                    },
                    _vm.incrementAdults,
                  ],
                },
              },
              [_vm._v("\n                    +\n                ")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form__validation" }, [
            _vm._v(_vm._s(_vm.errors.first("adults"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form__group" }, [
          _c(
            "label",
            { staticClass: "form__label", attrs: { for: "children" } },
            [_vm._v("Guests - Children")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form__increment" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--increment",
                attrs: { disabled: _vm.childGuests <= 0 },
                on: {
                  click: [
                    function ($event) {
                      $event.preventDefault()
                      if ($event.target !== $event.currentTarget) return null
                    },
                    _vm.decrementChildren,
                  ],
                },
              },
              [_vm._v("\n                    -\n                ")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.childGuests,
                  expression: "childGuests",
                },
                { name: "validate", rawName: "v-validate" },
              ],
              staticClass: "form__control form__guests",
              attrs: {
                id: "children",
                type: "number",
                name: "children",
                min: "0",
                max: "9",
                placeholder: "Enter company's name here...",
                required: "",
              },
              domProps: { value: _vm.childGuests },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.childGuests = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--increment",
                attrs: { disabled: _vm.childGuests >= 9 },
                on: {
                  click: [
                    function ($event) {
                      $event.preventDefault()
                      if ($event.target !== $event.currentTarget) return null
                    },
                    _vm.incrementChildren,
                  ],
                },
              },
              [_vm._v("\n                    +\n                ")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form__validation" }, [
            _vm._v(_vm._s(_vm.errors.first("children"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form__group" }, [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.dietaryRequirements,
                expression: "dietaryRequirements",
              },
              { name: "validate", rawName: "v-validate" },
            ],
            staticClass: "form__control",
            attrs: {
              id: "dietaryRequirements",
              name: "dietaryRequirements",
              placeholder: "Please specify...",
            },
            domProps: { value: _vm.dietaryRequirements },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.dietaryRequirements = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "form__label",
              attrs: { for: "dietaryRequirements" },
            },
            [_vm._v("Dietary Requirements")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form__validation" }, [
            _vm._v(_vm._s(_vm.errors.first("dietaryRequirements"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form__group" }, [
          _c("div", { staticClass: "toggle-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.requiresAccommodation,
                  expression: "requiresAccommodation",
                },
                { name: "validate", rawName: "v-validate" },
              ],
              staticClass: "toggle",
              attrs: {
                id: "accommodation",
                name: "accommodation",
                type: "radio",
                required: "",
              },
              domProps: {
                value: true,
                checked: _vm._q(_vm.requiresAccommodation, true),
              },
              on: {
                change: function ($event) {
                  _vm.requiresAccommodation = true
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "toggle", attrs: { for: "accommodation" } },
              [_vm._v("Yes")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.requiresAccommodation,
                  expression: "requiresAccommodation",
                },
                { name: "validate", rawName: "v-validate" },
              ],
              staticClass: "toggle",
              attrs: {
                id: "no-accommodation",
                name: "accommodation",
                type: "radio",
                required: "",
              },
              domProps: {
                value: false,
                checked: _vm._q(_vm.requiresAccommodation, false),
              },
              on: {
                change: function ($event) {
                  _vm.requiresAccommodation = false
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "toggle", attrs: { for: "no-accommodation" } },
              [_vm._v("No")]
            ),
          ]),
          _vm._v(" "),
          _c("label", { staticClass: "form__label" }, [
            _vm._v("Accommodation required?"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form__validation" }, [
            _vm._v(_vm._s(_vm.errors.first("is opportunity"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form__group" }, [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.roomRequirements,
                expression: "roomRequirements",
              },
              { name: "validate", rawName: "v-validate" },
            ],
            staticClass: "form__control",
            attrs: {
              id: "roomRequirements",
              name: "roomRequirements",
              placeholder: "Please specify...",
            },
            domProps: { value: _vm.roomRequirements },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.roomRequirements = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "form__label", attrs: { for: "roomRequirements" } },
            [_vm._v("Room requirements")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form__validation" }, [
            _vm._v(_vm._s(_vm.errors.first("roomRequirements"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form__group form__group--submit" }, [
          _c(
            "button",
            {
              directives: [
                {
                  name: "wait",
                  rawName: "v-wait:disabled",
                  value: "submit",
                  expression: '"submit"',
                  arg: "disabled",
                },
              ],
              staticClass: "btn btn--primary",
            },
            [_vm._v("Sign up")]
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }